import React, {useCallback, useContext, useEffect} from 'react';
import {setHash} from '../../utils/urlUtils';
import {AppContext} from '../../context';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
/* eslint-disable */

export const CalendarItems = ({
                                  openedControls,
                                  toggleLayer,
                                  layers,
                                  activeLayers,
                                  onToggle,
                                  selectedValues,
                                  closeCalendar,
                              }) => {
    const {configModal} = useContext(AppContext);
    const {t} = useTranslation();

    useEffect(() => {
        toggleLayer('background-sgp-full', 'basemap');
    }, [openedControls]);

    const onChangeValue = (e) => {
        toggleLayer(e.target.value, 'basemap');
    };

    const handleCalendarToggle = useCallback(
        (selectedValues, onToggle, basemap) => {
            if (
                selectedValues?.calendar &&
                selectedValues?.calendar.length > 0
            ) {
                onToggle('calendar', selectedValues?.calendar[0]);
            }

            onToggle('calendar', basemap.label.split('_')[1]);

            if (basemap.label.split('_')[1] === 'Full') {
                onToggle('calendar', 'Full');
            }
            setHash('basemap', basemap.name);
            configModal.handleSave(basemap.name);
        },
        [configModal]
    );
    return (
        <>
            {openedControls === 'calendar' && (
                <div className="calendar max-z-index">
                    <p className={'mb-5'}>{t('calendar.menuTitle')}</p>

                    <div id="date-slider">
                        {!!layers &&
                            layers.map((basemap) => (
                                <React.Fragment key={basemap.name}>
                                    <input
                                        checked={activeLayers === basemap.name}
                                        type="radio"
                                        name="date"
                                        id={basemap.label}
                                        value={basemap.name}
                                        onChange={onChangeValue}
                                        onClick={() => {
                                            handleCalendarToggle(
                                                selectedValues,
                                                onToggle,
                                                basemap
                                            );
                                        }}
                                        required
                                    />
                                    <label
                                        className={`${
                                            +basemap.label.replace('SGP_', '') <
                                            +activeLayers.replace(
                                                'background-sgp-',
                                                ''
                                            ) ||
                                            (activeLayers.includes('full') &&
                                                !basemap.label.includes('Full'))
                                                ? 'active'
                                                : ''
                                        }`}
                                        htmlFor={basemap.label}
                                        data-date={t(
                                            `project:basemap.${basemap.label}`
                                        )}
                                    />
                                </React.Fragment>
                            ))}

                        <div id="date-pos"/>
                    </div>
                    <div className={'calendar-close-btn'} onClick={closeCalendar}>
                        <div className="calendar-close"/>
                    </div>

                </div>
            )}
        </>
    );
};
CalendarItems.propTypes = {
    openedControls: PropTypes.string,
    controlsToggle: PropTypes.func,
    toggleLayer: PropTypes.func,
    onToggle: PropTypes.func,
    closeCalendar: PropTypes.func,
    layers: PropTypes.array,
    activeLayers: PropTypes.string,
    selectedValues: PropTypes.object,
};
